<template>
  <div class="upload">
    <v-card flat="flat" class="nuclear" v-if="profile.role == 4">
      <v-card-title class="nuclear-title"
        >Configuration / Settings</v-card-title
      >
      <v-card-text class="nuclear-content">
        <span>This feature is not available for View Only User</span>
      </v-card-text>
    </v-card>
    <v-card flat="flat" class="nuclear" v-else>
      <v-card-title class="nuclear-title">Configuration / Upload</v-card-title>
      <v-card-text>
        <div class="upload_part">
          <div class="control">
            <div class="upload-btn-wrapper">
              <upload-btn
                @file-update="update"
                class="upload_btn desktop"
                title="Upload"
                noTitleUpdate
              ></upload-btn>
              <upload-btn
                @file-update="update"
                class="upload_btn mobile"
                title="UPLOAD YOUR FILES"
                noTitleUpdate
              ></upload-btn>
            </div>
            <p>or</p>
          </div>
          <div class="drop">
            <div id="file-drag-drop">
              <form ref="fileform">
                <div class="document_icon"></div>
                <span class="drop-files">Drop files here to upload</span>
              </form>
            </div>
          </div>
          <p class="succession">{{ this.successMessage }}</p>
          <p class="failure">{{ this.errorMessage }}</p>
        </div>
        <div class="chart_part">
          <v-row>
            <v-col cols="12" sm="12" md="4" lg="4">
              <v-row>
                <v-col cols="12" sm="6" md="6" lg="12">
                  <div class="latest_upload">
                    <p class="date">{{ latest_upload_at }}</p>
                    <p><span class="bold">The Last File</span> Uploaded <router-link v-if="latest_upload != null" :to="{ name: 'report', params: { id: latest_upload.id } }">{{latest_upload.file_name}}</router-link></p>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="6" lg="12">
                  <div class="upload_number">
                    <p class="number">{{ total_uploads }}</p>
                    <p>
                      Total
                      <span class="bold">Files Uploaded</span>
                    </p>
                  </div>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" sm="12" md="8" lg="8">
              <div class="card">
                <div class="card_title">
                  <p class="uploads">Uploads Over Time</p>
                  <div class="not_mobile">
                    <div class="calendar">
                      <div class="prev_btn">
                        <v-btn @click="selectBackward">
                          <font-awesome-icon class="prev" icon="chevron-left" />
                        </v-btn>
                      </div>
                      <div class="calendar_week">
                        <font-awesome-icon class="week" icon="calendar-week" />
                        <p>{{ this.dateoption.name }}</p>
                      </div>
                      <div class="next_btn">
                        <v-btn @click="selectForward">
                          <font-awesome-icon
                            class="next"
                            icon="chevron-right"
                          />
                        </v-btn>
                      </div>
                    </div>
                    <p class="number">
                      Total:
                      <span>{{ this.chartTotal }}</span>
                    </p>
                  </div>
                </div>
                <div class="card_content">
                  <apexchart
                    ref="chart1"
                    type="line"
                    height="350"
                    :options="chartOptions"
                    :series="series"
                    :loading="loading"
                  />
                  <div class="mobile">
                    <div class="calendar">
                      <div class="prev_btn">
                        <v-btn>
                          <font-awesome-icon class="prev" icon="chevron-left" />
                        </v-btn>
                      </div>
                      <div class="calendar_week">
                        <font-awesome-icon class="week" icon="calendar-week" />
                        <p>This week</p>
                      </div>
                      <div class="next_btn">
                        <v-btn>
                          <font-awesome-icon
                            class="next"
                            icon="chevron-right"
                          />
                        </v-btn>
                      </div>
                    </div>
                    <p class="total">
                      Total:
                      <span class="bold">{{ total_uploads }}</span>
                    </p>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import { mapState, mapActions } from "vuex";
import UploadButton from "vuetify-upload-button";
import { stringify } from "querystring";
export default {
  data() {
    return {
      dragAndDropCapable: false,
      files: [],
      uploadTitle: "Upload",
      successMessage: "",
      errorMessage: "",
      dateoptions: [
        { id: 1, name: "This Week" },
        { id: 2, name: "Last Week" },
        { id: 3, name: "This Month" }
      ],
      dateoption: { id: 1, name: "This week" },
      //chart
      loading: false,
      series: [{ data: [] }],
      chartTotal: 0,
      chartOptions: {
        chart: {
          zoom: {
            enabled: false
          }
        },
        colors: ["#39b9a7"],
        dataLabels: {
          enabled: true,
          style: {
            colors: ["#404040"]
          }
        },
        stroke: {
          curve: "straight",
          width: 2
        },
        grid: {
          yaxis: {
            lines: {
              show: false
            }
          },
          xaxis: {
            lines: {
              show: true
            }
          }
        },
        tooltip: {
          enabled: false
        },
        xaxis: {
          categories: []
        },
        yaxis: {
          show: false
        }
      },
      days_thisweek: [],
      days_lastweek: [],
      days_thismonth: []
    };
  },
  components: {
    "upload-btn": UploadButton
  },
  mounted() {
    this.dragAndDropCapable = this.determineDragAndDropCapable();
    if (this.dragAndDropCapable) {
      [
        "drag",
        "dragstart",
        "dragend",
        "dragover",
        "dragenter",
        "dragleave",
        "drop"
      ].forEach(
        function(evt) {
          this.$refs.fileform.addEventListener(
            evt,
            function(e) {
              e.preventDefault();
              e.stopPropagation();
            }.bind(this),
            false
          );
        }.bind(this)
      );

      this.$refs.fileform.addEventListener(
        "drop",
        function(e) {
          for (let i = 0; i < e.dataTransfer.files.length; i++) {
            this.files.push(e.dataTransfer.files[i]);
          }
          this.submitFiles();
        }.bind(this)
      );
    }

    // GET UPLOAD INFO
    this.$store.dispatch("uploadInfo");
    this.$store.dispatch("uploadNumber", { filter: 1 }).then(response => {
      this.updateChart(response.data);
    });
  },
  computed: {
    total_uploads() {
      return this.$store.state.upload.total_uploads;
    },
    latest_upload() {
      return this.$store.state.upload.latest_upload;
    },
    latest_upload_at() {
      return this.$store.state.upload.latest_upload_at;
    },
    profile() {
      return this.$store.state.user.profile;
    },
  },
  methods: {
    determineDragAndDropCapable() {
      var div = document.createElement("div");
      return (
        ("draggable" in div || ("ondragstart" in div && "ondrop" in div)) &&
        "FormData" in window &&
        "FileReader" in window
      );
    },
    submitFiles() {
      let formData = new FormData();
      for (var i = 0; i < this.files.length; i++) {
        let file = this.files[i];
        formData.append("file", file);
      }
      this.successMessage = "Uploading";
      this.$store
        .dispatch("fileUpload", formData)
        .then(() => {
          this.successMessage = "You have uploaded the file successfully.";
          this.uploadTitle = "Upload";
          this.$store.dispatch("uploadNumber", { filter: 1 }).then(response => {
            this.updateChart(response.data);
          });
          this.$store.dispatch("aboutMe");
        })
        .catch(error => {
          this.errorMessage = "File Uploading Failure.";
          this.uploadTitle = "Upload";
        });
    },
    update(file) {
      let formData = new FormData();
      formData.append("file", file);
      this.successMessage = "Uploading";
      this.$store
        .dispatch("fileUpload", formData)
        .then(response => {
          this.successMessage = "You have uploaded the file successfully.";
          this.uploadTitle = "Upload";
          this.$store.dispatch("uploadNumber", { filter: 1 }).then(response => {
            this.updateChart(response.data);
          });
        })
        .catch(error => {
          this.errorMessage = "File Uploading Failure.";
          this.uploadTitle = "Upload";
        });
    },
    updateChart(data) {
      let selected_days = [];
      data.dates.map(item => {
        let upload = item.split("-");
        item = [upload[1], upload[2], upload[0]].join("/");
        selected_days.push(item);
      });
      this.series = [{ data: data.counts }];
      this.chartTotal = data.total;
      this.chartOptions = {
        chart: {
          zoom: {
            enabled: false
          }
        },
        colors: ["#39b9a7"],
        dataLabels: {
          enabled: true,
          style: {
            colors: ["#404040"]
          }
        },
        stroke: {
          curve: "straight",
          width: 2
        },
        grid: {
          yaxis: {
            lines: {
              show: false
            }
          },
          xaxis: {
            lines: {
              show: true
            }
          }
        },
        tooltip: {
          enabled: false
        },
        xaxis: {
          categories: selected_days,
          labels: {
            hideOverlappingLabels: false
          }
        },
        yaxis: {
          show: false
        }
      };
    },
    selectForward() {
      let dateId = this.dateoption.id;
      // dateoption 1=this week, 2=last week, 3=last month
      if (dateId == 3) {
        let selected_dateoption = this.dateoptions.filter(item => item.id == 1);
        this.dateoption = selected_dateoption[0];
        let filterId = this.dateoption.id;
        this.$store
          .dispatch("uploadNumber", { filter: filterId })
          .then(response => {
            this.updateChart(response.data);
          });
      } else if (dateId == 2) {
        let selected_dateoption = this.dateoptions.filter(
          item => item.id == dateId + 1
        );
        this.dateoption = selected_dateoption[0];
        let filterId = this.dateoption.id;
        this.$store
          .dispatch("uploadNumber", { filter: filterId })
          .then(response => {
            this.updateChart(response.data);
          });
      } else if (dateId == 1) {
        let selected_dateoption = this.dateoptions.filter(
          item => item.id == dateId + 1
        );
        this.dateoption = selected_dateoption[0];
        let filterId = this.dateoption.id;
        this.$store
          .dispatch("uploadNumber", { filter: filterId })
          .then(response => {
            this.updateChart(response.data);
          });
      }
    },
    selectBackward() {
      let dateId = this.dateoption.id;
      if (dateId == 1) {
        let selected_dateoption = this.dateoptions.filter(item => item.id == 3);
        this.dateoption = selected_dateoption[0];
        let filterId = this.dateoption.id;
        this.$store
          .dispatch("uploadNumber", { filter: filterId })
          .then(response => {
            this.updateChart(response.data);
          });
      } else if (dateId == 2) {
        let selected_dateoption = this.dateoptions.filter(
          item => item.id == dateId - 1
        );
        this.dateoption = selected_dateoption[0];
        let filterId = this.dateoption.id;
        this.$store
          .dispatch("uploadNumber", { filter: filterId })
          .then(response => {
            this.updateChart(response.data);
          });
      } else if (dateId == 3) {
        let selected_dateoption = this.dateoptions.filter(
          item => item.id == dateId - 1
        );
        this.dateoption = selected_dateoption[0];
        let filterId = this.dateoption.id;
        this.$store
          .dispatch("uploadNumber", { filter: filterId })
          .then(response => {
            this.updateChart(response.data);
          });
      }
    }
  }
};
</script>
